import { render, staticRenderFns } from "./help2.vue?vue&type=template&id=134bbd0a&scoped=true"
import script from "./help2.vue?vue&type=script&lang=js"
export * from "./help2.vue?vue&type=script&lang=js"
import style0 from "./help2.vue?vue&type=style&index=0&id=134bbd0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134bbd0a",
  null
  
)

export default component.exports